
import { Component, Vue, Ref } from 'vue-property-decorator'
import { getDownloadURL } from '@/utils/helper'
import { useUserStore } from '../../../store/user'
import { useReuseTabStore } from '@/store/reuse-tab'
import { useTokenStore } from '@/store/token'
import { useMixAuthStore } from '@/store/mix-auth'
import { GlobalActions } from '../../../../../../enums/globa'
import pinia from '@/store'
import FeedbackModel from './FeedbackModel.vue'

const reuseTabStore = useReuseTabStore(pinia)
const userStore = useUserStore(pinia)
const tokenStore = useTokenStore(pinia)
const mixAuthStore = useMixAuthStore(pinia)

@Component({
  components: {
    FeedbackModel,
  },
})
export default class HeaderUser extends Vue {
  @Ref('refFeedbackModel')
  private refFeedbackModel!: FeedbackModel

  private userStore = userStore
  private userInfoModal = false
  private changePwdModal = false

  private created() {
    if (!this.userStore.info.userId) {
      this.userStore.logged()
    }
  }
  private handleCommand(e) {
    switch (e.key) {
      case 'setting':
        window.history.pushState(null, '', '/fire/settings')
        break
      case 'forgot':
        this.changePwdModal = true
        break
      case 'feedback':
        this.refFeedbackModel.show()
        break
      case 'logout':
        {
          reuseTabStore.clear()
          tokenStore.clear()
          mixAuthStore.clear()
          this.userStore.logout()
          this.$setGlobalState({
            action: GlobalActions.SignOut,
            userInfo: {},
            token: '',
          })
        }
        break
      default:
        break
    }
  }
  private get avatarSrc() {
    return this.userStore.info.headPortraitCode ? getDownloadURL(this.userStore.info.headPortraitCode) : undefined
  }
}
